(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glittercorn-catalog-filter"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('glittercorn-catalog')) {
  customElements.define('glittercorn-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.grid = this.querySelector('[data-grid]');
      if (!this.grid) return;
      this.age = this.querySelector('select[data-age]');
      this.category = this.querySelector('select[data-category]');
      this.sort = this.querySelector('[data-sort]');
      this.status = this.querySelector('[data-load-status]');
      this.retry = this.querySelector('[data-retry]');
      this.addEventListener('change', () => this.applyFilters());
      this.retry.addEventListener('click', () => this.loadCatalog());
      this.loadCatalog();
    }

    async loadCatalog() {
      this.retry.hidden = true;
      const cards = Array.from(this.grid.querySelectorAll('[data-card]'));
      const pages = Number(this.grid.dataset.pages);
      this.status.textContent = pages > 1 ? 'Loading all lovely finds…' : '';
      this.grid.setAttribute('aria-busy', 'true');
      try {
        for (let page = 1; page <= pages; page++) {
          if (page === Number(this.grid.dataset.page)) continue;
          const url = new URL(window.location.href);
          url.searchParams.set('section_id', this.dataset.sectionId);
          url.searchParams.set(this.grid.dataset.pageParam, String(page));
          const response = await fetch(url);
          if (!response.ok) throw new Error('Catalog request failed');
          const document = new DOMParser().parseFromString(await response.text(), 'text/html');
          const catalog = Array.from(document.querySelectorAll('glittercorn-catalog'))
            .find(element => element.dataset.sectionId === this.dataset.sectionId);
          const grid = catalog?.querySelector('[data-grid]');
          if (!grid || Number(grid.dataset.page) !== page) throw new Error('Missing catalog page');
          cards.push(...grid.querySelectorAll('[data-card]'));
        }
        if (cards.length !== Number(this.grid.dataset.total)) throw new Error('Incomplete catalog');
        this.cards = cards.sort((a, b) => Number(a.dataset.index) - Number(b.dataset.index));

        // Categories from Category blocks (in block order, separated by |) come first,
        // then any extra categories found on products.
        const configured = (this.dataset.categories || '')
          .split('|')
          .map(item => item.trim())
          .filter(Boolean);
        const seen = new Set();
        const categories = [];
        configured.forEach(name => {
          const key = name.toLowerCase();
          if (!seen.has(key)) { seen.add(key); categories.push(name); }
        });
        [...new Set(cards.map(card => card.dataset.category).filter(Boolean))]
          .sort((a, b) => a.localeCompare(b))
          .forEach(name => {
            const key = name.toLowerCase();
            if (!seen.has(key)) { seen.add(key); categories.push(name); }
          });
        this.category.replaceChildren(new Option('All', ''));
        categories.forEach(category => this.category.add(new Option(category, category)));

        this.querySelector('[data-pagination]').hidden = true;
        [this.age, this.category, this.sort].forEach(select => { select.disabled = false; });
        this.status.textContent = '';
        this.applyFilters();
      } catch {
        this.status.textContent = 'The full catalog could not be loaded. Browse using the page links or retry to enable filters.';
        this.retry.hidden = false;
      } finally {
        this.grid.setAttribute('aria-busy', 'false');
      }
    }

    applyFilters() {
      if (!this.cards) return;
      const sorted = [...this.cards];
      const number = (card, key) => Number(card.dataset[key]);
      const selectedCategory = this.category.value.toLowerCase();
      sorted.sort((a, b) => {
        let difference = 0;
        if (this.sort.value === 'low') difference = number(a, 'price') - number(b, 'price');
        if (this.sort.value === 'high') difference = number(b, 'price') - number(a, 'price');
        if (this.sort.value === 'newest') difference = number(b, 'created') - number(a, 'created');
        return difference || number(a, 'index') - number(b, 'index');
      });
      let count = 0;
      sorted.forEach(card => {
        card.hidden = Boolean((this.age.value && card.dataset.age !== this.age.value) ||
          (selectedCategory && (card.dataset.category || '').toLowerCase() !== selectedCategory));
        if (!card.hidden) count++;
      });
      this.grid.replaceChildren(...sorted);
      this.querySelector('[data-count]').textContent = `Showing ${count} lovely finds`;
      this.querySelector('[data-empty]').hidden = count !== 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
